import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la repeticion",
    opening: localizedGenderNode(
      [
      "Hoy no intento detener la repeticion.",
      "Solo noto: vuelve."
    ],
      [
      "Hoy no intento detener la repeticion.",
      "Solo noto: vuelve."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando empieza a correr la repeticion?",
      "Que momento vuelve más?",
      "Que siento ahi?"
    ],
      [
      "Cuando empieza a correr la repeticion?",
      "Que momento vuelve más?",
      "Que siento ahi?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una repeticion es una experiencia, no un veredicto final."
    ],
      [
      "Una repeticion es una experiencia, no un veredicto final."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Esto es una repeticion\".",
      "una respiracion + \"Esto es una repeticion\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que empieza la repeticion.",
      "Solo noto."
    ],
      [
      "Hoy noto el momento en que empieza la repeticion.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa justo antes de que empiece?",
      "En que momento del día pasa?",
      "Que temo que vean?"
    ],
      [
      "Que pasa justo antes de que empiece?",
      "En que momento del día pasa?",
      "Que temo que vean?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando veo el momento, tengo un pequeño espacio."
    ],
      [
      "Cuando veo el momento, tengo un pequeño espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando empieza la repeticion.",
      "una respiracion cuando empieza la repeticion."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se sienta la tension en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde se sienta la tension en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta protegerme."
    ],
      [
      "Mi cuerpo intenta protegerme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el hecho desnudo aquí?",
      "Que historia salto?",
      "Que posibilidad más suave podria ser cierta?"
    ],
      [
      "Cual es el hecho desnudo aquí?",
      "Que historia salto?",
      "Que posibilidad más suave podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El dolor debajo",
    opening: localizedGenderNode(
      [
      "Hoy toco el dolor debajo de la critica.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco el dolor debajo de la critica.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me duele en esta repeticion?",
      "Que temo que piensen de mi?",
      "Que necesitaba escuchar?"
    ],
      [
      "Que me duele en esta repeticion?",
      "Que temo que piensen de mi?",
      "Que necesitaba escuchar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El dolor es una peticion de cercanía."
    ],
      [
      "El dolor es una peticion de cercanía."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mi.",
      "una frase suave para mi."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "La voz critica",
    opening: localizedGenderNode(
      [
      "Hoy escucho la voz critica sin pelear con ella."
    ],
      [
      "Hoy escucho la voz critica sin pelear con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como suena esa voz?",
      "Que intenta proteger?",
      "Que me gustaria decirle?"
    ],
      [
      "Como suena esa voz?",
      "Que intenta proteger?",
      "Que me gustaria decirle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz es solo una voz."
    ],
      [
      "Una voz es solo una voz."
    ]
    ),
    action: localizedGenderNode(
      "notarla sin creerla.",
      "notarla sin creerla."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La necesidad de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad de seguridad debajo de la repeticion.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad de seguridad debajo de la repeticion.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentirme seguro/a?",
      "Que puede ayudar a calmar mi cuerpo?",
      "Que me gustaria darme ahora?"
    ],
      [
      "Que necesito para sentirme seguro/a?",
      "Que puede ayudar a calmar mi cuerpo?",
      "Que me gustaria darme ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un poco de seguridad cambia el tono."
    ],
      [
      "Un poco de seguridad cambia el tono."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra de seguridad.",
      "escribir una palabra de seguridad."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Soltarlo un momento",
    opening: localizedGenderNode(
      [
      "Hoy veo como se siente soltar la repeticion por un momento.",
      "Solo un momento."
    ],
      [
      "Hoy veo como se siente soltar la repeticion por un momento.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Dejo que mi cuerpo se ablande un poco.",
      "Una respiracion."
    ],
      [
      "Dejo que mi cuerpo se ablande un poco.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa en mi cuando lo suelto un momento?",
      "Que me asusta de soltarlo?",
      "Que me calma aunque sea un poco?"
    ],
      [
      "Que pasa en mi cuando lo suelto un momento?",
      "Que me asusta de soltarlo?",
      "Que me calma aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Soltarlo un momento tambien es elegir."
    ],
      [
      "Soltarlo un momento tambien es elegir."
    ]
    ),
    action: localizedGenderNode(
      "un momento sin repetir.",
      "un momento sin repetir."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un lenguaje interno suave",
    opening: localizedGenderNode(
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ],
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como me hablo despues de la reunion?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ],
      [
      "Como me hablo despues de la reunion?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz suave baja la presion."
    ],
      [
      "Una voz suave baja la presion."
    ]
    ),
    action: localizedGenderNode(
      "decir la frase suave una vez.",
      "decir la frase suave una vez."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Un momento antes del juicio",
    opening: localizedGenderNode(
      [
      "Hoy pauso un momento antes del juicio sobre mi.",
      "Solo un momento."
    ],
      [
      "Hoy pauso un momento antes del juicio sobre mi.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de juzgar.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de juzgar.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que frase de juicio salta?",
      "Cual es su costo para mi?",
      "Que podria decir en su lugar?"
    ],
      [
      "Que frase de juicio salta?",
      "Cual es su costo para mi?",
      "Que podria decir en su lugar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño momento cambia la direccion."
    ],
      [
      "Un pequeño momento cambia la direccion."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave en lugar de juicio.",
      "una frase suave en lugar de juicio."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Volver al presente",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ],
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ],
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ],
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El presente me da suelo."
    ],
      [
      "El presente me da suelo."
    ]
    ),
    action: localizedGenderNode(
      "sentir mis pies un momento.",
      "sentir mis pies un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Un momento antes de comprobar",
    opening: localizedGenderNode(
      [
      "Hoy pauso antes de volver a comprobar.",
      "Solo un momento."
    ],
      [
      "Hoy pauso antes de volver a comprobar.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de comprobar.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de comprobar.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que intento asegurar ahora?",
      "Que pasa si no lo se de inmediato?",
      "Que puede ayudarme a esperar un momento?"
    ],
      [
      "Que intento asegurar ahora?",
      "Que pasa si no lo se de inmediato?",
      "Que puede ayudarme a esperar un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Esperar un momento es fuerza tranquila."
    ],
      [
      "Esperar un momento es fuerza tranquila."
    ]
    ),
    action: localizedGenderNode(
      "pausar antes de comprobar.",
      "pausar antes de comprobar."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño que me calma.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un paso pequeño que me calma.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ],
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que paso pequeño puede ayudarme a soltar?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ],
      [
      "Que paso pequeño puede ayudarme a soltar?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño basta."
    ],
      [
      "Lo pequeño basta."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño.",
      "elegir un paso pequeño."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ],
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ],
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi de esta repeticion?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ],
      [
      "Que aprendi de esta repeticion?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo un momento antes de responder."
    ],
      [
      "Elijo un momento antes de responder."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + mi frase.",
      "una respiracion + mi frase."
    ),
  },
].map(buildNormalizedDay);

export const replayAfterMeetingBlueprintEs = buildNormalizedPilotBlueprint({
  id: "replay_after_meeting_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "replay_after_meeting",
  category: "anxiety",
  journeyName: {
    he: "replay בראש אחרי פגישה - \"למה אמרתי ככה...\"",
    en: "Replay in my head after a meeting - \"Why did I say that...\"",
    es: "Repeticion en mi cabeza despues de una reunion - \"Por que dije eso...\"",
  },
  days,
});

export default replayAfterMeetingBlueprintEs;
